import Vue from 'vue'
import VueRouter from 'vue-router'
import adminRoutes from './admin'
import generalRoutes from './general'

Vue.use(VueRouter)

const allRoutes = []
const routes = allRoutes.concat(adminRoutes, generalRoutes)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
